export enum ToastrMessages {
	empty = '',
	heatMapDisabled = 'Thematic Map can not be applied at this level. returning to free mode.',
	cannotApplyHeatMap = 'This Thematic Map can not be applied at this level.',
	cannotApplyFilters = 'This Filter can not be applied at this level.',
	unableToPostSummaryFilters = 'Unable to post filter data. Please try again later.',
	unableToLoadSummary = 'Unable to load summary data. Please try again later.',
	unableToSearch = 'Unable to search. Please try again later.',
	unableToFetchUserPreferences = 'Unable to fetch user preferences. Please try again later.',
	unableToFetchUserHistory = 'Unable to fetch user history. Please try again later.',
	unableToPostHistory = 'Unable to post user history. Please try again later.',
	unableToUpdateUserPreferences = 'Unable to update user preferences. Please try again later.',
	unableToFetchFilters = 'Unable to fetch filters. Please try again later.',
	unableToFetchHeatMapFilters = 'Unable to fetch thematic map filters. Please try again later.',
	unableToFetchHeatMapData = 'Unable to fetch thematic map data. Please try again later.',
	unableToPostFilterData = 'Unable to post filter data to server. Please try again later.',
	unableToRequestAccess = 'Unable to process the request. Please try again later.',
	cannotSetViewContext = 'Unable to set the view. Please try again later.',
	dcrViewError = 'Error while viewing DCR document',
	affectionPlanViewError = 'Error while viewing Affection Plan document',
	dcrDocumentDownloadError = 'Error while downloading DCR document',
	affectionPlanDownloadError = 'Error while downloading Affection Plan document',
	viewError = 'Error while viewing document',
	downloadError = 'Error while downloading document',
	heatMapTimeoutError = 'Heatmap request timed out. Please try again later.',
	filterTimeoutError = 'Filter request timed out. Please try again later.',
	noFiltersSelected = 'No filters selected or server error. Please try again later.',
	heatMapResponseError = 'No data found for the selected heatmap criteria.',
	noFilterDataAvailable = 'No data found for the selected filter criteria.',
	cannotApplyFilterOnDossier = 'This filter can not be applied on dossier.',
	insightsNotAvailable = 'Insights are not available for the selected sector or community.',
	kpisGraphsNotAvailable = 'Error while trying to fetch the graphs',
	kpisNotAvailable = 'Error while trying to fetch the kpi data',
	kpiCategoriesNotAvailable = 'Error while trying to fetch the categories',
	kpiLocationsNotAvailable = 'Error while trying to fetch the locations',
	kpiTypeViewNotAvailable = 'Error while trying to fetch the user view types',
}
